/**
 * Describes one SDK-to-Gateway operation without exposing HTTP routes or methods.
 *
 * The request and response types exist only at compile time. The operation name
 * is the stable runtime identifier used by transport implementations.
 */
export interface CommerceOperation<TRequest, TResponse> {
    readonly name: string;

    /** Type-only markers preserve request and response inference. */
    readonly requestType?: TRequest;
    readonly responseType?: TResponse;
}

/**
 * Creates a typed Commerce operation token.
 *
 * Operation definitions should be exported once and reused by the SDK,
 * transports, tests, and custom integrations.
 */
export function defineCommerceOperation<TRequest, TResponse>(
    name: string,
): CommerceOperation<TRequest, TResponse> {
    const normalizedName = name.trim();

    if (normalizedName.length === 0) {
        throw new TypeError(
            "Commerce operation names must contain at least one non-whitespace character.",
        );
    }

    return Object.freeze({
        name: normalizedName,
    });
}
